import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=7aab0d0b&scoped=true&lang=css"

import exportComponent from "/home/miras_zxc/vc-master/_work/verification-center-front/verification-center-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7aab0d0b"]])

export default __exports__